import { PostAdjusterOpinionQueryParamsType } from '@/modules/adjusterReportModules/adjusterReport/queries/adjusterOpinion/postAdjusterOpinion/postAdjusterOpinionQuery.type';
import { postAdjusterOpinionFunction } from '@/modules/adjusterReportModules/adjusterReport/queries/adjusterOpinion/postAdjusterOpinion/postAdjusterOpinionQueryFunction';
import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const postAdjusterOpinionQueryOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  PostAdjusterOpinionQueryParamsType
> => {
  return {
    mutationKey: ['adjusterOpinion'],
    mutationFn: (data: PostAdjusterOpinionQueryParamsType) =>
      postAdjusterOpinionFunction(data),
  };
};
